function updateIndexMap(indexMap, i, j, func) {
	const itemA = indexMap[i];
	const itemB = indexMap[j];
	indexMap.splice(Math.max(i, j), 1);
	indexMap.splice(Math.min(i, j), 1);
	indexMap.push(func(itemA, itemB));
}
export { updateIndexMap };

//# sourceMappingURL=index92.js.map